export enum types {
	ALL = "all",
	SCHEDULE = "schedule",
	UNIT_GROUPS = "unitGroups",
	DRIVER_GROUPS = "driverGroups",
	AUTH_USER = "authUser",
	AUTH_SESSION = "authSession",
	WIALON_EVENTS = "wialonEvents",
}
